import React from 'react';
import styles from './TableBox.module.scss';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, ImgCell } from '@/components/TableCell';

const TableBox = ({
    tableData: {
        dataList = [],
        pageNum = 1,
        pageSize = 30,
        resultTotal = 0
    },
    onPageChange,
    renderModal
}) => {

    const onOperateCell = (id, item) => {
        return <div className={styles.action}>
            {
                item.auditState === 'WAIT_AUDIT' &&
                <div className={styles.item} onClick={() => renderModal({ renderModal: true, id, type: 'audit', title: '头像/昵称审核' })}>审核</div>
            }
            <div className={styles.item} onClick={() => renderModal({ renderModal: true, id, type: 'detail', title: '头像/昵称详情' })}>查看详情</div>
        </div>;
    };

    const picNickCell = (test, item) => {
        if (test === 'NICKNAME') {
            return tooltip(item.relateValue);
        } else {
            return ImgCell(item.relateValue);
        }
    };

    const columns = [
        {
            title: '手机号码',
            dataIndex: 'phone',
            key: 'phone',
            width: '14%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '头像/昵称',
            dataIndex: 'auditType',
            key: 'auditType ',
            width: '14%',
            align: 'center',
            onCell: tooltipStyle,
            render: picNickCell
        },
        {
            title: '会员身份',
            dataIndex: 'userTypeDesc',
            key: 'userTypeDesc',
            width: '14%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '申请时间',
            dataIndex: 'applyTime',
            key: 'applyTime',
            width: '14%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'auditStateDesc',
            key: 'auditStateDesc',
            width: '14%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '审核人员',
            dataIndex: 'auditUserName',
            key: 'auditUserName',
            width: '14%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            width: '14%',
            align: 'center',
            onCell: tooltipStyle,
            render: onOperateCell
        }
    ];

    return <div className={styles.tableContainer}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={record => record.id}
            columns={columns}
            dataSource={dataList}
            pagination={false}
            scroll={{ y: true }}
        />
        <XPagination
            resultTotal={resultTotal}
            pageSize={pageSize}
            pageNum={pageNum}
            onChange={onPageChange}
        />
    </div>;
};

TableBox.propTypes = {
    onPageChange: PropTypes.func,//分页变化
    tableData: PropTypes.object,//表格数据
    renderModal: PropTypes.func
};

export default TableBox;